import React, { Component } from 'react';
import SPurchaseFlow from 'shared/screens/PurchaseFlow';
import { Row, Col, Spinner } from 'react-bootstrap';
import { isTablet } from 'react-device-detect';
import { PurchaseTypes } from 'shared/utils/routeParamConstants';
import BillingProfile from './BillingProfile';
import CreditCardDetails from './CreditCardDetails';
import WebFinishPurchase from '../../components/WebFinishPurchase';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { PaymentProviders } from 'shared/utils/paymentProviders';
import PurchaseFlowComponent from './components/PurchaseFlow';
import { ThemeContext } from 'styled-components';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import Button from '../../components/Button/Button';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import {
  wrapperStyle,
  defaultHeaderContainerStyle,
  headerHeightStyle,
  titleStyle,
} from './components/styledComponents';
import PurhaseFlowHeader from './components/PurchaseFlowHeader';
import LazyImage from '../../components/LazyImage/LazyImage';
import { TAG } from 'shared/constants';
import { isNotStandaloneMobilePWA } from '../../utils/mobileSupported';
import { PromoActionKey } from 'shared/utils/PromotionAction';

/** @typedef {import('shared/api/Constants').BoostPackageItem} Consumable */

export default class PurchaseFlow extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: `gtp-modal-purchase  ${!isTablet && isNotStandaloneMobilePWA && 'gtp-modal-purchase-small'}`,
      dismissPromoAction: PromoActionKey.GO_TO_COIN_STORE,
    };
  }

  onSubmit = (nextHandle, validatedData) => {
    nextHandle(true, validatedData);
  };

  submitAddress = (nextHandle, validatedData) => {
    nextHandle(true, validatedData, true);
  };

  getRenderable = (provider, hasOffer, props, stage, validationStage, nextHandle, errorMessage) => {
    const themeContext = this.context;

    if (stage === 1) {
      return (
        <div>
          {provider === PaymentProviders.CAMS && (
            <PurchaseFlowComponent
              onSubmit={this.submitAddress}
              errorMessage={errorMessage}
              props={props}
              hasOffer={hasOffer}
              getPurchaseStrings={this.getPurchaseStrings}
              renderTotal={this.renderTotal}
              paymentProvider={provider}
            />
          )}
        </div>
      );
    } else if (stage === 2 && provider === PaymentProviders.CAMS) {
      return (
        <div>
          {provider === PaymentProviders.CAMS && (
            <div style={themeContext.PurchaseFlow.CreditCardDetails}>
              <CreditCardDetails
                hasOffer={hasOffer}
                getPurchaseStrings={this.getPurchaseStrings}
                renderTotal={this.renderTotal}
                onSubmit={this.onSubmit}
                paymentProvider={provider}
                {...props}
              />
            </div>
          )}
        </div>
      );
    } else {
      this.onSubmit(nextHandle, validationStage >= stage);
    }
  };

  render() {
    return (
      <SPurchaseFlow
        navigation={this.props.navigation}
        render={props => {
          const { stage, nextHandle, validationStage, purchaseType, contactSupport, offerDetail, errorMessage } = props;
          let hasOffer = offerDetail ? true : false;
          let renderable = null;
          const themeContext = this.context;

          switch (stage) {
            case -1:
              renderable = <Spinner />;
              break;
            case 0:
              renderable = (
                <BillingProfile
                  hasOffer={hasOffer}
                  getPurchaseStrings={this.getPurchaseStrings}
                  renderTotal={this.renderTotal}
                  termsAndConditionsURL={this.props.termsAndConditionsURL}
                  {...props}
                />
              );
              break;
            case 1:
              renderable = this.getRenderable(
                this.props.paymentProvider,
                hasOffer,
                props,
                stage,
                validationStage,
                nextHandle,
                errorMessage
              );
              break;
            case 2:
              renderable = this.getRenderable(
                this.props.paymentProvider,
                hasOffer,
                props,
                stage,
                validationStage,
                nextHandle,
                errorMessage
              );
              break;
            case 3:
              renderable = <WebFinishPurchase navigation={this.props.navigation} />;
              break;
            case 5:
              renderable = this.renderStage3(contactSupport, themeContext);
              break;
            default:
              renderable = null;
          }

          const title = `${getText(TEXT_KEY.PURCHASE)} ${
            purchaseType === 'currency'
              ? getText(TEXT_KEY.COINS)
              : purchaseType === 'vip'
                ? `${getText(TEXT_KEY.VIP)} ${getText(TEXT_KEY.ACCESS)}`
                : purchaseType === PurchaseTypes.PIGGY_BANK
                  ? getText(TEXT_KEY.PIIGY_BANK_PURCHSASE_HEADER)
                  : getText(TEXT_KEY.BOOST)
          }`;

          return (
            <div className={`form-container ${isTablet ? 'isTablet' : ''}`}>
              {stage < 3 && (
                <PurhaseFlowHeader
                  titleStyle={titleStyle}
                  headerHeightStyle={headerHeightStyle}
                  headerTitleWrapperStyle={defaultHeaderContainerStyle}
                  wrapperStyle={wrapperStyle}
                  containerStyle={themeContext.PurchaseFlow.PurhaseFlowHeader.HeaderContainerStyle}
                  title={title.toUpperCase()}
                />
              )}
              {renderable}
            </div>
          );
        }}
      />
    );
  }

  getPurchaseStrings = (purchaseType, packageData, hasOffer) => {
    const { promoLink } = this.props;
    let purchaseNameString = '';
    let purchasePriceString = getText(TEXT_KEY.CURRENCY_SIGN);

    switch (purchaseType) {
      case PurchaseTypes.CURRENCY:
        let amount;
        if (promoLink && promoLink.active && !hasOffer) {
          amount = packageData.PROMO_BOOSTED_VALUE;
        } else {
          amount = packageData.AMOUNT;
        }
        purchaseNameString += `${amount} ${getText(TEXT_KEY.COINS)}`;
        purchasePriceString += packageData?.PRICE ?? 0;
        break;
      case PurchaseTypes.VIP:
      case PurchaseTypes.CONSUMABLE:
        purchaseNameString += packageData.name;
        purchasePriceString += packageData.price;
        break;
      case PurchaseTypes.PIGGY_BANK:
        purchaseNameString += `${amount} ${getText(TEXT_KEY.COINS)}`;
        purchasePriceString += packageData?.PRICE ?? 0;
        break;
      default:
    }

    return { purchaseNameString, purchasePriceString };
  };

  renderStage3(contactSupport, themeContext) {
    return (
      <>
        <div className="form-title" data-label={'OOPS'}>
          <span>{'OOPS'}</span>
          <LazyImage
            tag={TAG.IMG}
            src={assetSource(ASSET_KEY.PURCHASE_LIGHT_DIVIDER)}
            alt=""
            style={{
              position: 'absolute',
              width: '100%',
              top: '100%',
              pointerEvents: 'none',
              left: 0,
            }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img
            style={{ width: '9%', zIndex: 1, margin: '1rem 0' }}
            src={assetSource(ASSET_KEY.WARNING_SYMBOL)}
            alt=""
          />
          <span style={{ fontWeight: 500 }}>{getText(TEXT_KEY.TRANSACTION_COULD_NOT_BE_PROCESSED)}</span>
          <span style={{ fontWeight: 500 }}>
            {getText(TEXT_KEY.NEED_HELP)} {getText(TEXT_KEY.CONTACT_CUSTOMER_SUPPORT)}
          </span>
          <Button
            imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_DANGER)}
            containerStyle={{ width: '100%', padding: '2rem' }}
            onClick={contactSupport}
            label={getText(TEXT_KEY.CONTACT_BUTTON)}
            textStyle={themeContext.PurchaseFlow.ContactUsButtonTextStyle}
            textStroke={BUTTON_STROKES.DANGER}
          />
        </div>
      </>
    );
  }

  /**
   * @param  {String} item
   * @param  {String} price
   * @param  {import('../../../../shared/api/Constants').PromoCodeReward|String} promoReward
   */
  renderTotal(item, price) {
    return (
      <Row>
        <Col className={'totalContainer'}>
          <div
            className={`gradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
            data-label={item.toUpperCase()}
            style={{
              lineHeight: 1,
              fontSize: '3vmin',
              fontWeight: '600',
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '3.5vmin',
            }}
          ></div>
          <div className={'price'}>
            <span>{getText(TEXT_KEY.TOTAL)}</span>
            <span>{price}</span>
          </div>
        </Col>
      </Row>
    );
  }
}

PurchaseFlow.contextType = ThemeContext;

